
namespace ts.词典完成 {
    let 跳过的集合 = createMap<boolean>()
    export function 取词典自动完成项目(sourceFile: SourceFile, position: number, ignoreName: string): 词典完成条目 {
        if (ignoreName) {
            跳过的集合.set(ignoreName, true)
        }
        if (!position) {
            return
        }
        if (!sourceFile) {
            return
        }
        if (sourceFile.text.length < position) {
            return
        }
        if (!sourceFile.isDeclarationFile) {
            return;
        }
        const 声明集 = sourceFile.getNamedDeclarations()
        if (!声明集) {
            return
        }
        let 是字面量: boolean
        let 范围: Range
        const 找到名称: string = forEachEntry(声明集, (声明组, 名称) => {
            return forEach(声明组, 声明 => {
                if (声明.getFullStart() < position && position < 声明.getStart()) {
                    let name = getDeclarationName(声明)
                    if (name && !name.别名 && name.text && name.text === 名称) {
                        if (isStringLiteral(name)) {
                            是字面量 = true
                        }
                        跳过的集合 = createMap<boolean>()
                        let 前点 = 转换位置为行数及字符偏移(sourceFile, name.getStart()) as Position
                        let 后点 = 转换位置为行数及字符偏移(sourceFile, name.getEnd()) as Position
                        范围 = { start: 前点, end: 后点 }
                        return 名称
                    } else {
                        return 找子节点(声明)
                    }
                }
            })
            function 找子节点(n: Declaration): string {
                let name = getDeclarationName(n)
                if (name && !name.别名 && name.text && !跳过的集合.get(name.text as string)) {
                    if (isStringLiteral(name)) {
                        是字面量 = true
                    }
                    let 前点 = 转换位置为行数及字符偏移(sourceFile, name.getStart()) as Position
                    let 后点 = 转换位置为行数及字符偏移(sourceFile, name.getEnd()) as Position
                    范围 = { start: 前点, end: 后点 }
                    return name.text as string
                }
                return forEachChild(n, 找子节点)
            }
        })
        return { name: 找到名称, range: 范围, isStringLiteral: 是字面量, rangeMap: 取词典替换范围项目(sourceFile, 找到名称) }
    }

    function 取词典替换范围项目(sourceFiles: SourceFile[] | SourceFile, 键名称: string): RangeMap {
        if (!键名称) {
            return
        }
        if (!sourceFiles) {
            return
        }
        let 文件集: SourceFile[]
        if (!isArray(sourceFiles)) {
            文件集 = [sourceFiles]
        } else {
            文件集 = sourceFiles
        }
        let 返回结果集: RangeMap = {}
        for (let sou of 文件集) {
            if (!sou.isDeclarationFile) {
                continue
            }
            let 全部名称集合 = 取别名全表(sou)
            if (全部名称集合) {
                let 相同名称集: RangeInfo[] = 全部名称集合.get(键名称)
                if (相同名称集) {
                    返回结果集[sou.fileName] = 相同名称集
                }
            }
        }
        return 返回结果集
    }
}
